import React, { useEffect, useRef, useState } from "react";
import "antd/dist/antd.min.css";
import { Modal, Table, Button } from "antd";
import {
  sortableContainer,
  sortableElement,
  sortableHandle,
} from "react-sortable-hoc";
import { MenuOutlined, PlusOutlined } from "@ant-design/icons";
import { useSelector, useDispatch } from "react-redux";
import { refreshMenuGroupAction } from "hooks/actions/etcAction";
import getMenuInfo from "controllers/getMenuInfo";
import styled from "styled-components";
import InsertMenuGroup from "./InsertMenuGroup";
import EditMenuGroup from "./EditMenuGroup";
import axios from "axios";
import { authAction } from "hooks/actions/mainAction";
import { menuAction } from "hooks/actions/etcAction";

const backend = process.env.REACT_APP_BACKEND;
const StyledA = styled.a`
  margin-left: 5px;
  margin-right: 5px;
`;

const DragHandle = sortableHandle(({ active }) => (
  <MenuOutlined style={{ cursor: "grab", color: active ? "blue" : "#999" }} />
));

const SortableItem = sortableElement((props) => <tr {...props} />);
const SortableContainer = sortableContainer((props) => <tbody {...props} />);

function MenuGroup() {
  const dispatch = useDispatch();
  const insertMenuGroupRef = useRef(null);
  const editMenuGroupRef = useRef(null);
  const [insertPopup, setInsertPopup] = useState(false);
  const [editPopup, setEditPopup] = useState(false);
  const [nowData, setNowData] = useState(null);
  const menuGroupList = useSelector((state) => state.etcReducer.allMenuGroup);

  const dndFun = (data) => {
    try {
      return data.map((el, idx) => {
        return {
          id: el.id,
          menu_group_code: "A" + ("000" + el.id).slice(-3),
          menu_group_name: el.menu_group_name,
          google_otp_use_yn: el.google_otp_use_yn,
          delete_yn: el.delete_yn,
          order: el.order,
          index: el.id, // index없을 경우 unique key필요 에러 발생
        };
      });
    } catch (err) {
      console.log(err);
    }
  };

  const dataSourceRaw = dndFun(menuGroupList);
  const [dataSource, setDataSource] = useState(dataSourceRaw);
  const [selectedItems, setSelectedItems] = useState([]);
  if (dataSourceRaw.length !== 0 && dataSource.length === 0) {
    setDataSource(dataSourceRaw);
  }

  const getColumns = () => {
    return [
      {
        title: "순서",
        dataIndex: "",
        width: 80,
        className: "drag-visible",
        render: (d, dd, i) => (
          <>
            <DragHandle active={selectedItems.includes(i)} />
          </>
        ),
      },
      {
        title: "영역 코드",
        dataIndex: "menu_group_code",
        className: "drag-visible",
        width: "150px",
      },
      {
        title: "영역 명칭",
        dataIndex: "menu_group_name",
        width: "150px",
      },
      {
        title: "MFA 인증 필요",
        dataIndex: "google_otp_use_yn",
        render: (yn) => (yn === "Y" ? "필요" : "불필요"),
        width: "150px",
      },
      {
        title: "삭제",
        dataIndex: "delete_yn",
        render: (_, record) =>
          record.delete_yn === "Y" ? (
            <>
              <StyledA
                onClick={() => {
                  editHandler(record);
                }}
              >
                수정
              </StyledA>
              <StyledA
                onClick={() => {
                  deleteHandler(record);
                }}
              >
                삭제
              </StyledA>
            </>
          ) : (
            <>
              <StyledA
                onClick={() => {
                  editHandler(record);
                }}
              >
                수정
              </StyledA>
            </>
          ),
      },
    ];
  };
  const merge = (a, b, i = 0) => {
    let aa = [...a];
    return [...a.slice(0, i), ...b, ...aa.slice(i, aa.length)];
  };
  const onSortEnd = ({ oldIndex, newIndex }) => {
    let tempDataSource = dataSource.map((el) => {
      return el;
    });
    if (oldIndex !== newIndex) {
      if (!selectedItems.length) {
        let movingItem = tempDataSource[oldIndex];
        tempDataSource.splice(oldIndex, 1);
        tempDataSource = merge(tempDataSource, [movingItem], newIndex);
      } else {
        let filteredItems = [];
        selectedItems.forEach((d) => {
          filteredItems.push(tempDataSource[d]);
        });
        let newData = [];
        tempDataSource.forEach((d, i) => {
          if (!selectedItems.includes(i)) {
            newData.push(d);
          }
        });
        tempDataSource = [...newData];
        tempDataSource = merge(tempDataSource, filteredItems, newIndex);
      }
      // -------------  결과처리 부분 -----------
      let newDataSource = tempDataSource.map((el, idx) => {
        return el.id;
      });
      getMenuInfo
        .menuGroupOrder(newDataSource)
        .then((data) => {
          if (data[0]) {
            getMenuInfo
              .menuGroupList()
              .then((data) => {
                if (data.length === 0) {
                  dispatch(authAction(false, null));
                } else {
                  dispatch(refreshMenuGroupAction(data)); //전체 메뉴그룹을 바꾸는 액션
                }
              })
              .catch((err) => {
                console.log(err);
              });

            getMenuInfo
              .userMenu()
              .then((data) => {
                if (data.length === 0) {
                  dispatch(authAction(false, null));
                } else {
                  dispatch(menuAction(data.userMenuGroupList, data.menuList)); // 유저에 해당하는 메뉴그룹과 메뉴를 바꾸는 액션
                }
              })
              .catch((err) => {
                console.log(err);
              });
          } else {
            Modal.error({
              title: "순서변경 에러",
              content: "에러가 발생하여 정상적으로 순서를 변경하지 못했습니다.",
              afterClose: () => {
                setDataSource(dataSource);
              },
            });
          }
        })
        .catch((err) => {
          Modal.error({
            title: "순서변경 에러",
            content: "에러가 발생하여 정상적으로 순서를 변경하지 못했습니다.",
            afterClose: () => {
              setDataSource(dataSource);
            },
          });
        });

      setDataSource(tempDataSource);
      setSelectedItems([]);
    }
  };

  const DraggableContainer = (props) => (
    <SortableContainer
      useDragHandle
      disableAutoscroll
      helperClass="row-dragging"
      onSortEnd={onSortEnd}
      {...props}
    />
  );

  const DraggableBodyRow = ({ className, style, ...restProps }) => {
    // function findIndex base on Table rowKey props and should always be a right array index
    const index = dataSource.findIndex(
      (x) => x.index === restProps["data-row-key"]
    );
    return (
      <SortableItem
        index={index}
        {...restProps}
        selected={selectedItems.length}
        onClick={(e) => {
          if (e.ctrlKey || e.metaKey) {
            selectedItems.includes(index)
              ? selectedItems.splice(selectedItems.indexOf(index), 1)
              : selectedItems.push(index);
            setSelectedItems(selectedItems);
          } else {
            setSelectedItems([]);
          }
        }}
      />
    );
  };

  function insertHandler() {
    // Modal.confirm({
    //   title:"모달",
    //   content: <Insert></Insert>
    // })
    setInsertPopup(true);
  }
  function insertCancelHandler() {
    insertMenuGroupRef.current.resetFields();
    setInsertPopup(false);
  }
  async function insertOkHandler() {
    insertMenuGroupRef.current
      .validateFields()
      .then((data) => {
        axios
          .post(`${backend}/admin_menu/insert_menu_group`, { value: data })
          .then((data) => {
            const newData = dndFun(data.data.data);
            setDataSource(newData);
            setInsertPopup(false);
            insertMenuGroupRef.current.resetFields();
            Modal.success({
              title: "등록완료",
              okText: "확인",
              content: "정상적으로 등록 되었습니다.",
            });
          })
          .catch((err) => {
            if (err.response.status === 401) {
              dispatch(authAction(false, null));
            }
            console.log(err);
          });
      })
      .catch((err) => {
        console.log(err);
      });
  }
  function resetValue() {
    insertMenuGroupRef.current.resetFields();
  }

  function resetEditPopup() {
    editMenuGroupRef.current.resetFields();
  }

  function deleteHandler(e) {
    Modal.confirm({
      title: "삭제 확인",
      content: "삭제를 하시면 복구할 수 없습니다. 그래도 삭제를 하시겠습니까?",
      okButtonProps: { type: "default" },
      cancelButtonProps: { type: "primary" },
      okText: "삭제",
      cancelText: "취소",
      onOk: () => {
        axios
          .post(`${backend}/admin_menu/delete_menu_group`, { value: e.id })
          .then((data) => {
            const newData = dndFun(data.data.data);
            setDataSource(newData);
            Modal.success({
              title: "삭제 완료",
              okText: "확인",
              content: "정상적으로 삭제되었습니다.",
            });
          })
          .catch((err) => {
            if (err.response.status === 401) {
              dispatch(authAction(false, null));
            }
            console.log(err);
          });
      },
    });
  }
  function editHandler(e) {
    setNowData(e);
    setEditPopup(true);
  }

  function editCancelHandler() {
    setEditPopup(false);
  }
  async function editOkHandler() {
    const value = await editMenuGroupRef.current.validateFields();
    axios
      .post(`${backend}/admin_menu/edit_Menu_Group`, { value })
      .then((data) => {
        const newData = dndFun(data.data.data);
        setDataSource(newData);
        setEditPopup(false);
        Modal.success({
          title: "수정 완료",
          okText: "확인",
          content: "정상적으로 수정되었습니다.",
        });
      })
      .catch((err) => {
        if (err.response.status === 401) {
          dispatch(authAction(false, null));
        }
        console.log(err);
      });
  }

  useEffect(() => {
    getMenuInfo
      .menuGroupList()
      .then((data) => {
        if (data.length === 0) {
          dispatch(authAction(false, null));
        } else {
          dispatch(refreshMenuGroupAction(data)); //전체 메뉴그룹을 바꾸는 액션
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, [dataSource, dispatch]);

  useEffect(() => {
    getMenuInfo
      .userMenu()
      .then((data) => {
        if (data.length === 0) {
          dispatch(authAction(false, null));
        } else {
          dispatch(menuAction(data.userMenuGroupList, data.menuList)); // 유저에 해당하는 메뉴그룹과 메뉴를 바꾸는 액션
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, [dataSource, dispatch]);

  return (
    <div style={{height:"100%", display:"flex", flexDirection:"column"}}>
      <Modal
        open={insertPopup}
        title="관리영역 등록"
        maskClosable={false}
        onCancel={insertCancelHandler}
        footer={
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <Button onClick={resetValue}>내용 초기화</Button>
            <span>
              <Button type="primary" onClick={insertOkHandler}>
                등록
              </Button>
              <Button onClick={insertCancelHandler}>취소</Button>
            </span>
          </div>
        }
      >
        <InsertMenuGroup dataSource={dataSource} ref={insertMenuGroupRef} />
      </Modal>
      <Modal
        destroyOnClose={true}
        open={editPopup}
        title="관리영역 수정"
        maskClosable={false}
        onCancel={editCancelHandler}
        footer={
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <Button onClick={resetEditPopup}>내용 초기화</Button>
            <span>
              <Button type="primary" onClick={editOkHandler}>
                수정
              </Button>
              <Button onClick={editCancelHandler}>취소</Button>
            </span>
          </div>
        }
      >
        <EditMenuGroup
          info={nowData}
          dataSource={dataSource}
          ref={editMenuGroupRef}
        />
      </Modal>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: "10px",
        }}
      >
        <span>관리영역 목록</span>
        <Button onClick={insertHandler}>
          <PlusOutlined />
          관리영역 등록
        </Button>
      </div>
        <div style={{width:"100%", height:"100%", overflow:"auto"}}>
      <Table
        pagination={false}
        dataSource={dataSource}
        columns={getColumns()}
        rowKey="index"
        scroll={{ x: 700, y:"100%"}}
        components={{
          body: {
            wrapper: DraggableContainer,
            row: DraggableBodyRow,
          },
        }}
      />
      </div>
      {selectedItems.length ? <>{selectedItems.length} items selected </> : ""}
    </div>
  );
}

export default MenuGroup;
